import React, { useState } from 'react';
import { getGlobalData } from "../lib/globalData"
import Slider from '../lib/slider';

const Register = props => {
  const [user, setUser] = useState({});

  const { dataprovider, staticel, userinfo, setUserField, is_dev } = props;

  const handleUserChange = (key) => (ev) => {
    setUser({...user, [key]:ev.target.value});
  }
  const doneUserSet = (res) => {
    const us = {...user, id:res.id, msg:res.msg};
    setUser(us);
    setUserField('id', res.id);
    if (res.id) {
      window.location.href ='/app2#register';
    }
  }
  const handleRegister = (ev) => {
    const data = {...user, front:true};
    dataprovider.insert('user', data, doneUserSet);
  }

  const saml = user.email && user.email.match(/.+@schulegossau.ch/);
  var isValid = true;
  const inValid = {};
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!user.email || !re.test(String(user.email).toLowerCase())) {
    inValid.email = true;
    isValid = false;
  }
  const re2 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/
  if (!user.password || !re2.test(String(user.password))) {
    inValid.password = true;
    isValid = false;
  }
  if (user.password!==user.password_rep) {
    inValid.password_rep = true;
    isValid = false;
  }  
  
  if (userinfo.id || user.id) {
    return (
      <>
        <Slider staticel={staticel} page={8} is_dev={is_dev} />
        <div className="container mt-5">
          <div className="row ms-0 mb-1 mt-3 p-3" style={{backgroundColor:'#E3F0F6', borderRadius:'15px'}}>
            <div className="col">
              <h4>Herzlich Willkommen in der soundolino Community</h4>
            {userinfo.license!==1?
              <p>Du kannst jetzt im <a href="/app#shop">Shop</a> fertige Produkte bestellen, oder eine <a href="/app#shop/s114">Lizenz</a> lösen, um selber Projekte zu gestalten.</p>
            :
              <p>Für dich wurde eine Pauschallizenz aktiviert.<br/><br/>Du kannst jetzt im <a href="/app#shop">Shop</a> fertige Produkte bestellen oder im  <a href="/app#creator">Creator</a> selber Projekte zu gestalten.</p>
            }
            </div>
          </div>
        </div>
      </>
    )
  }
  
  return (
    <>
      <Slider staticel={staticel} page={2} is_dev={is_dev} />
      <div className="container pt-5 mt-5">
        <h2>Neu registrieren bei soundolino</h2>
    {user.msg && <h5 className="text-danger">{user.msg}</h5>}    
        <div className="row mb-2 align-items-center">
          <div className="col-5 col-lg-3 text-end">E-Mail</div>
          <div className="col-7 col-lg-5">
            <input type="email" value={user.email} onChange={handleUserChange('email')} className={"form-control"+(inValid.email?" is-invalid":"")} />
          </div>
        </div>
    {!saml &&
      <>
        <div className="row mb-2 align-items-center">
          <div className="col-5 col-lg-3 text-end">Passwort</div>
          <div className="col-7 col-lg-5">
            <input type="password" value={user.password} onChange={handleUserChange('password')} className={"form-control"+(inValid.password?" is-invalid":"")} />
            <div className="invalid-feedback">Min. 8 Zeichen, muss Gross- und Kleinbuchstaben sowie Zahlen enthalten.</div>
          </div>
        </div>
        <div className="row mb-2 align-items-center">
          <div className="col-5 col-lg-3 text-end">Passwort wiederholen</div>
          <div className="col-7 col-lg-5">
            <input type="password" value={user.password_rep} onChange={handleUserChange('password_rep')} className={"form-control"+(inValid.password_rep?" is-invalid":"")} />
          </div>
        </div>
        <div className="row mb-2 align-items-center">
          <div className="col-5 col-lg-3"></div>
          <div className="col-7 col-lg-5">
            Mit der Registration erkläre ich mich mit den <button className="link" data-bs-toggle="modal" data-bs-target="#agb">AGB</button> und der <button className="link"  href="#" data-bs-toggle="modal" data-bs-target="#datenschutz">Datenschutzerklärung</button> einverstanden.
          </div>
        </div>
        <div className="row mb-2 ">
          <div className="col-5 col-lg-3 text-end"></div>
          <div className="col-7 col-lg-5">
            <button type="button" className={"btn btn-"+(isValid?"primary":"secondary")+" mt-4"}  disabled={!isValid} onClick={handleRegister}>Kostenlos registrieren</button>
          </div>
        </div>
      </>
    }
    {saml &&
        <div className="row mb-2 align-items-center">
          <div className="col-5 col-lg-3"></div>
          <div className="col-7 col-lg-5">
            <h5>Direkt über <a href="/app#login">Login anmelden</a></h5>
          </div>
        </div>
    }
      </div>
    </>
  )
}

export default Register;
